<template>
  <b-navbar toggleable="lg">
    <router-link :to="{ name: Routes.home}" :active="currentRoute == 'home'" class="navbar-brand">
      <img src="../assets/faith-logo.png" height="80" alt="Faith Church Logo" />
    </router-link>
    <b-navbar-toggle target="nav-collapse" />
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item :active="currentRoute == 'home'">
          <router-link :to="{ name: Routes.home}" class="nav-link">Home</router-link>
        </b-nav-item>
        <b-nav-item :active="currentRoute == 'videos'">
          <router-link :to="{ name: Routes.videos}" class="nav-link">Sermons</router-link>
        </b-nav-item>
        <b-nav-item :active="currentRoute == 'about'">
          <router-link :to="{ name: Routes.about}" class="nav-link">About Us</router-link>
        </b-nav-item>
        <b-nav-item :active="currentRoute == 'jerry'">
          <router-link :to="{ name: Routes.jerry}" class="nav-link">Pastor Jerry</router-link>
        </b-nav-item>
        <b-nav-item :active="currentRoute == 'contact'">
          <router-link :to="{ name: Routes.contact}" class="nav-link">Contact</router-link>
        </b-nav-item>
        <b-nav-item>
          <b-button variant="success" @click="openGiveModal">Give</b-button>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script lang="ts">
import Modals from "../classes/Modals";
import Routes from "../classes/Routes";

export default {
  name: "Navigation",
  data() {
    return {
      Routes: Routes
    };
  },
  methods: {
    openGiveModal() {
      this.$root.$emit("bv::show::modal", Modals.give);
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name;
    }
  }
};
</script>